import {text_mod_57, } from "../text/Text.js";
export const module57 = {
  title:
    "§57. Спонукальні речення. Інтонація",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_57, },
    ]
  }
